﻿(function (document) {

    document.addEventListener("DOMContentLoaded", function () {
        var openModals = document.querySelectorAll('.checkout-modal__container.open:not(.behave-as-modal)');
        if (openModals.length > 0) {
            document.querySelector('body').classList.add('checkout-modal__overlayWrapper');

            openModals.forEach(function (modal) {
                modal.querySelectorAll('a[href="#close"]').forEach(function (element) {
                    element.addEventListener('click', function (e) {
                        e.preventDefault();
                        modal.classList.remove('open');
                        document.querySelector('body').classList.remove('checkout-modal__overlayWrapper');
                    });
                });
            });
        }

        document.querySelectorAll('.checkout-modal__overlay.auto-close').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelectorAll('.checkout-modal__container.open').forEach(function (modal) {
                    modal.classList.remove('open');
                });
                document.querySelector('body').classList.remove('checkout-modal__overlayWrapper');
            });
        });
    });

    document.ShowModal = function (modal) {
        // if there are no elements, we're done
        if (!modal) { return; }

        // if we have a selector, get the chosen elements
        if (typeof (modal) === 'string') {
            modal = document.querySelector(modal);
        }

        modal.classList.add('open');
        document.querySelector('body').classList.add('checkout-modal__overlayWrapper');
        modal.querySelectorAll('a[href="#close"]').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                modal.classList.remove('open');
                document.querySelector('body').classList.remove('checkout-modal__overlayWrapper');
            });
        });
    };
})(document);